// extracted by mini-css-extract-plugin
export default {"copyPasteTip":"lfRAqt","appear":"UZEEZB","copyPasteText":"JFEEUK","copyPasteLink":"cTJYfm","copyPasteClose":"u6U37N"};